import { ReactComponent as GooglePlay } from 'assets/icons/icon-googleplay.svg';

export default GooglePlay;
